export default __webpack_public_path__ + "static/media/photo--lg--blitz-3.cba4d71b.jpg";